import PropTypes from 'prop-types';
import HighCharts from '../HighCharts';

import s from './PolarChartBlock.module.css';

const PolarChartBlock = ({
    title,
    displayLargeTitle,
    showTitleInToc,
    polarChartValueType,

    yAxisLabel,
    yAxisStackValues = false,
    yAxisMin,
    yAxisMax,
    yAxisTickInterval,

    decimalPlaces,

    xAxisLabel,
    xAxisLabelFormattting,
    xAxisCategorySortingType,
    xAxisCategoryOrdering,

    aggregateDataByCategory,

    propertySeriesQueries,
    aggregateSeriesQueries,

    dynamicProperty,
    enableLineSymbols = true,
}) => {
    const plotOptions = {
        series: {
            stacking: yAxisStackValues,
            dataLabels: {
                // enabled: yAxisStackValues,
                enabled: false,
            },
            marker: {
                enabled: enableLineSymbols,
            },
        },
    };

    return (
        <div className={s.Root}>
            <HighCharts
                chartType="polar"
                polarChartValueType={polarChartValueType}
                title={title}
                showTitleInToc={showTitleInToc}
                displayLargeTitle={displayLargeTitle}
                yAxisLabel={yAxisLabel}
                yAxisMin={yAxisMin}
                yAxisMax={yAxisMax}
                yAxisTickInterval={yAxisTickInterval}
                decimalPlaces={decimalPlaces}
                xAxisLabel={xAxisLabel}
                xAxisLabelFormattting={xAxisLabelFormattting}
                xAxisCategorySortingType={xAxisCategorySortingType}
                xAxisCategoryOrdering={xAxisCategoryOrdering}
                aggregateDataByCategory={aggregateDataByCategory}
                propertySeriesQueries={propertySeriesQueries}
                aggregateSeriesQueries={aggregateSeriesQueries}
                dynamicProperty={dynamicProperty}
                plotOptions={plotOptions}
            />
        </div>
    );
};

PolarChartBlock.propTypes = {
    title: PropTypes.string,
    displayLargeTitle: PropTypes.bool,
    showTitleInToc: PropTypes.bool,

    xAxisLabel: PropTypes.string,
    yAxisStackValues: PropTypes.bool,
    xAxisLabelFormattting: PropTypes.string,
    xAxisCategorySortingType: PropTypes.string,
    xAxisCategoryOrdering: PropTypes.string,

    yAxisLabel: PropTypes.string,
    yAxisMin: PropTypes.number,
    yAxisMax: PropTypes.number,
    yAxisTickInterval: PropTypes.number,

    decimalPlaces: PropTypes.number,

    aggregateDataByCategory: PropTypes.bool,

    propertySeriesQueries: PropTypes.array,
    aggregateSeriesQueries: PropTypes.array,

    dynamicProperty: PropTypes.string,
    enableLineSymbols: PropTypes.bool,
};

export default PolarChartBlock;
